import { Dispatch } from "@reduxjs/toolkit";
import {
  setStreamingGuidanceMessage,
  setImageNextStage,
  setShowCaptureAnimation,
} from "src/store/inspectionCaptureSlice";
import { resetCurrentAnalyzedResult } from "src/store/inspectionResultsSlice";

/**
 * Resets streaming-related state to clean values
 * 
 * This should be called when:
 * - User completes a question
 * - User cancels/closes a dialog
 * - Streaming session needs to restart
 * 
 * @param dispatch - Redux dispatch function
 */
export const resetStreamingState = (dispatch: Dispatch) => {
  dispatch(setStreamingGuidanceMessage(""));
  dispatch(setImageNextStage(null));
  dispatch(setShowCaptureAnimation(false));
  dispatch(resetCurrentAnalyzedResult());
};
